import { useQuery, useQueryClient } from '@tanstack/react-query';
import CatalogService from '@utility/services/catalog';
import { catalogKeys } from '../lib/query-keys';

/* A parent's variations, asked for only while its row is open. */
export function useCatalogVariations(
  parentId: string,
  search: string,
  enabled: boolean,
) {
  const term = search.trim();

  return useQuery({
    queryKey: catalogKeys.variations(parentId, term),
    queryFn: async () => {
      const result = await CatalogService.variations(
        `${parentId}${term ? `?search=${encodeURIComponent(term)}` : ''}`,
        /* The query cache is the cache now; the legacy one is still written. */
        true,
      );

      return result.data ?? [];
    },
    enabled,
  });
}

export function useInvalidateCatalogVariations() {
  const queryClient = useQueryClient();

  return (parentId: string) =>
    queryClient.invalidateQueries({
      queryKey: catalogKeys.variationsOf(parentId),
    });
}
